window.HF_QUICKADD_ALLOWED = [
  'title','product_title',
  'price','variant-picker','quantity-selector','buy-buttons',
  'pack','bundle','short-text','icon-payment','rating-custom',
  'clickable-discount','text','long-text','file-upload','checkbox-option',
  'radio-option','dropdown','date-input','inventory','rating','icon-with-text','description'
];

window.HF_QUICKADD_DENY = new Set([
  'popup','product_modal','modal-dialog','modal','product-popup',
  'pickup-availability','size-chart'
]);

(function(){
  const norm = s => (s||'').toLowerCase().trim().replace(/[^a-z0-9]+/g,'_');

  function buildAllowed(){
    const base = (window.HF_QUICKADD_ALLOWED || []).map(norm);
    const set  = new Set(base);

    if (set.has('title')) set.add('product_title');
    if (set.has('product_title')) set.add('title');

    if (set.has('buy_buttons') || set.has('buy_button')) {
      set.add('buy_buttons');
      set.add('buy_button');
    }
    return set;
  }

  function resolveTypeFromId(id, allowed){
    const after = (String(id).split('__')[1] || '');
    let tok = norm(after);             
    if (allowed.has(tok)) return tok;  

    let probe = tok;
    while (probe.includes('_')) {
      probe = probe.slice(0, probe.lastIndexOf('_')); 
      if (allowed.has(probe)) return probe;           
    }
    return tok; 
  }

  window.HF_PRUNE_DEBUG = false;

  window.HF_pruneBlocksForQuickAdd = function(productInfoEl){
    if (!productInfoEl) return;

    const allowed = buildAllowed();
    const deny    = window.HF_QUICKADD_DENY || new Set();

    productInfoEl.querySelectorAll([
      '[id^="PopupModal-"]','modal-dialog','.product-popup-modal',
      '[class*="product-popup-modal__opener-"]','.sizechart-anchor'
    ].join(',')).forEach(el => el.remove());

    productInfoEl.querySelectorAll('.shopify-block[id^="shopify-block-"]').forEach(bl => {
      const t = resolveTypeFromId(bl.id, allowed);
      const remove = deny.has(t) || !allowed.has(t);
      if (remove) {
        if (window.HF_PRUNE_DEBUG) console.debug('[QuickAdd] remove', t, bl.id);
        bl.remove();
      } else if (window.HF_PRUNE_DEBUG) {
        console.debug('[QuickAdd] keep  ', t, bl.id);
      }
    });
  };
})();
